import { Injectable, inject } from '@angular/core';

import { BuildDetails, BuildDetailsService } from './build-details.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BuildDetailsHttpService {
  private http = inject(HttpClient);
  private buildDetailsService = inject(BuildDetailsService);

  fetchBuildDetails(): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache',
        hideLoader: 'true',
      }),
    };

    return new Promise((resolve) => {
      firstValueFrom(this.http.get<BuildDetails>('assets/build-details.json', httpOptions)).then((response) => {
        this.buildDetailsService.buildDetails = response;
        resolve(response);
      });
    });
  }
}
